// src/lib/lead/actions/sendLeadFlow.ts
import type { Lead } from "@/types/lead";

export type EvalDupesResult = {
  severity: "none" | "warn" | "block";
  matches: Lead[];
  reason?: string | null;
};

export type SendLeadFlowDeps = {
  // inputs
  evaluateDuplicates: (lead: Lead) => EvalDupesResult;

  // send
  sendToGHL: (lead: Lead) => void;

  // modal state wiring
  setPendingSendLead: (lead: Lead | null) => void;
  setDuplicateMatches: (leads: Lead[]) => void;
  setDuplicateReason: (reason: string | null) => void;
  setMergeSuggestion: (v: any) => void;

  // voice
  canSpeakHelp: boolean;
  speak?: (text: string) => void;
};

export function handleSendLeadClick(lead: Lead, deps: SendLeadFlowDeps) {
  const evalDupes = deps.evaluateDuplicates(lead);

  if (evalDupes.severity !== "block") {
    // No blocking duplicates – send directly
    deps.sendToGHL(lead);
    return;
  }

  // Blocking duplicates found – prompt the manager
  deps.setPendingSendLead(lead);
  deps.setDuplicateMatches(evalDupes.matches);
  deps.setDuplicateReason(evalDupes.reason ?? null);
  deps.setMergeSuggestion(null);

  if (deps.canSpeakHelp && deps.speak) {
    deps.speak("I found another lead that looks like the same customer. Please review the duplicates before sending.");
  }
}